import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

export default function Header(props) {
  const { title, image, description, url } = props;
  return (
    <Helmet>
      <title>{title ? `Realbricks | ${title}` : 'Realbricks'}</title>
      <meta name='title' content={title} />
      <meta property='og:title' content={title} />
      <meta property='og:image' content={image} />
      <meta property='twitter:image' content={image} />
      <meta property='description' content={description} />
      <meta property='og:description' content={description} />
      <meta property='og:url' content={url} />

      <meta charset='UTF-8' />
      <meta name='author' content='Realbricks' />
      <meta property='og:type' content='website' />
      <meta property='og:site_name' content={`Realbricks | ${title}`} />
      <meta name='twitter:image:alt' content='Realbricks' />
      <meta name='twitter:card' content='summary_large_image' />
    </Helmet>
  );
}

Header.propTypes = {
  title: PropTypes.string,
  image: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
};
